import '../../App.css';
import bg1 from '../../img/bg1.jpg';
import ReCAPTCHA from 'react-google-recaptcha';

function Step1({
  setPage,
  page,
  tipoDoc,
  setTipoDoc,
  tipoDocAlert,
  setTipoDocAlert,
  numDoc,
  numDocAlert,
  setNumDocAlert,
  emailAlert,
  setEmailAlert,
  setNumDoc,
  email,
  setEmail,
  captcha,
  setCaptcha,
  validation,
}) {
  const isAllowedToPass = () => {
    if (validationPage1()) {
      setPage((currentPage) => currentPage + 1);
    }
  };

  const validarMail = (mail) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    } else {
      //setEmailAlert(true)
      return false;
    }
  };

  const validacionesRut = {
    // Valida el rut con su cadena completa "XXXXXXXX-X"
    validaRut: function (rutCompleto) {
      rutCompleto = rutCompleto.replace(/\./g, '')
      if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
      var tmp = rutCompleto.split('-');
      var digv = tmp[1];
      var rut = tmp[0];
      if (digv == 'K') digv = 'k';
      return validacionesRut.dv(rut) == digv;
    },
    dv: function (T) {
      var M = 0,
        S = 1;
      for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
      return S ? S - 1 : 'k';
    },
  };

  const validarRut = (value) => {
    if (validacionesRut.validaRut(value)) {
      return true;
    } else {
      return false;
    }
  };

  const validationPage1 = () => {
    let isOk = true;
    if (tipoDoc === '') {
      isOk = false;
      setTipoDocAlert('error_label');
    }

    if (!validarMail(email)) {
      isOk = false;
      setEmailAlert('error_label');
    }

    if (tipoDoc === 1){
      if (!validarRut(numDoc)) {
        isOk = false;
        setNumDocAlert('error_label');
      }
    }

    if (captcha === false) {
      isOk = false;
    }
    return isOk;
  };

  function formatRut(rut) {
    // Ensure input is a string
    rut = String(rut);
  
    // Remove any non-digit character
    rut = rut.replace(/[^\dKk]+/g, '');

    // Split the RUT into the number and the verification digit
    let number = rut.slice(0, -1);
    const verificationDigit = rut.slice(-1);
  
    // Format the RUT with dots and a slash
    let formattedRut = "";
    let i = 0;
    while (number.length > 3) {
      formattedRut = "." + number.slice(-3) + formattedRut;
      number = number.slice(0, -3);
      i++;
    }
    formattedRut = number + formattedRut + "-" + verificationDigit;
  
    // Return the formatted RUT
    return formattedRut;
  }
  
  const handleChangeNumDoc = (value) => {
    if(tipoDoc == 1){
        // Format the input value
        const formattedValue = formatRut(value);
        // Update the state with the formatted value
        setNumDoc(formattedValue);
    }else{
    setNumDoc(value);
    }
  }
  return (
    <section id="paso--2" class="step style--2 w3-animate-top">
      <div class="section--bg img--bg ">
        <img class="first" src={bg1} alt="" />
      </div>
      <div class="in display_flex">
        <header class="marquee">
          <div class="in">
            <div class="maxwidth">
              <div class="logo gone"></div>
              <div class="ttl">
                <span class="num fonty">{page + 1}</span>
                <h2>Bienvenido</h2>
              </div>
              <div class="air gone"></div>
            </div>
          </div>
        </header>
        <main>
          <div class="maxwidth3">
            <div class="cols cols2">
              <div class="col col1 form-step-1">
                <div class="list">
                  <div class="field select">
                    <label>
                      <span class="name">
                        <span>Documento</span>
                      </span>
                      <div>
                        <select
                          id="tipoDoc"
                          class={tipoDocAlert}
                          value={tipoDoc}
                          onChange={(e) => {
                            setTipoDoc(e.target.value);
                            setTipoDocAlert('required empty');
                            if(numDoc !== ''){
                              setNumDoc('')
                            }
                          }}
                          name="tipoDoc"
                        >
                          <option value="">Seleccione Rut o Pasaporte</option>
                          <option value="1">RUT</option>
                          <option value="2">Pasaporte</option>
                        </select>
                      </div>
                    </label>
                  </div>
                  <div class="field input">
                    <label>
                      <span class="name">
                        <span>Nº</span>
                      </span>
                      <input
                        value={numDoc}
                        class={numDocAlert}
                        type="text"
                        id="numDoc"
                        placeholder="Ej: 1.111.111-1"
                        onChange={(e) => {
                          handleChangeNumDoc(e.target.value);
                          setNumDocAlert('required empty');
                        }}
                        name="numDoc"
                      />
                    </label>
                  </div>
                  <div class="field input">
                    <label>
                      <span class="name">
                        <span>E-mail</span>
                      </span>
                      <input
                        value={email}
                        class={emailAlert}
                        type="text"
                        id="email"
                        placeholder="Ej: hola@mail.com"
                        onChange={(e) => {
                          setEmail(e.target.value);
                          setEmailAlert('required empty');
                        }}
                        name="email"
                      />
                    </label>
                  </div>
                  <div className="gcatch text--center">
                    <ReCAPTCHA sitekey="6Lfd5u8mAAAAAGu0hSeZJV3b9bkzHk5ej0MtIOWm" onChange={(e) => setCaptcha(true)} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="button submit">
            <button
              name="button_sumbit"
              id="button_sumbit"
              onClick={() => {
                isAllowedToPass();
              }}
            >
              Continuar &darr;
            </button>
          </div>
        </main>
      </div>
    </section>
  );
}

export default Step1;
